import { resolveComponent as a, openBlock as t, createElementBlock as i, normalizeClass as c, normalizeStyle as m, toDisplayString as d, createBlock as n, resolveDynamicComponent as g, createCommentVNode as h } from "vue";
import { _ as u } from "./_plugin-vue_export-helper-dad06003.js";
import { U as f } from "./UserSingleIcon-e28f0f63.js";
const p = {
  name: "AvatarMd",
  components: {
    UserSingleIcon: f
  },
  props: {
    image: {
      type: String,
      default: ""
    },
    name: {
      type: String,
      default: ""
    },
    borderColor: {
      type: String,
      default: ""
    },
    textColor: {
      type: String,
      default: ""
    },
    icon: {
      type: String || Object,
      default: ""
    },
    imgUrl: {
      type: String,
      default: ""
    }
  },
  computed: {
    imageWithImgUrl() {
      return this.image && (this.image.startsWith("http") || this.image.startsWith("https")) ? this.image : this.image ? this.imgUrl + this.image : null;
    },
    initials() {
      return this.name.split(" ").slice(0, 2).map((o) => {
        var r;
        return (r = o[0]) == null ? void 0 : r.toUpperCase();
      }).join("");
    }
  }
}, b = { class: "relative flex-shrink-0" }, S = ["src"], x = {
  key: 0,
  class: "text-lg font-semibold"
};
function C(o, r, e, y, _, l) {
  const s = a("UserSingleIcon");
  return t(), i("div", b, [
    e.image ? (t(), i("img", {
      key: 0,
      src: l.imageWithImgUrl,
      alt: "",
      class: "h-12 w-12 rounded-full object-cover"
    }, null, 8, S)) : (t(), i("div", {
      key: 1,
      class: c(["h-12 w-12 rounded-full flex items-center justify-center text-gray-500 dark:text-neutral-200", [e.borderColor ? "border" : "ct-bg-3"]]),
      style: m({
        color: e.textColor,
        borderColor: e.borderColor
      })
    }, [
      e.name ? (t(), i("p", x, d(l.initials), 1)) : (t(), n(s, {
        key: 1,
        class: "h-6 w-6"
      }))
    ], 6)),
    e.icon ? (t(), n(g(e.icon), {
      key: 2,
      class: "absolute -top-1 -left-1 w-4 h-4"
    })) : h("", !0)
  ]);
}
const B = /* @__PURE__ */ u(p, [["render", C]]), k = {
  name: "AvatarSm",
  components: {
    UserSingleIcon: f
  },
  props: {
    image: {
      type: String,
      default: ""
    },
    name: {
      type: String,
      default: ""
    },
    borderColor: {
      type: String,
      default: ""
    },
    textColor: {
      type: String,
      default: ""
    },
    icon: {
      type: [String, Object],
      default: ""
    },
    imgUrl: {
      type: String,
      default: ""
    }
  },
  computed: {
    imageWithImgUrl() {
      return this.image && (this.image.startsWith("http") || this.image.startsWith("https")) ? this.image : this.image ? this.imgUrl + this.image : null;
    },
    initials() {
      return this.name.split(" ").slice(0, 2).map((o) => {
        var r;
        return (r = o[0]) == null ? void 0 : r.toUpperCase();
      }).join("");
    }
  }
}, U = { class: "relative flex-shrink-0" }, v = ["src"], I = {
  key: 0,
  class: "text-base font-semibold"
};
function j(o, r, e, y, _, l) {
  const s = a("UserSingleIcon");
  return t(), i("div", U, [
    e.image ? (t(), i("img", {
      key: 0,
      src: l.imageWithImgUrl,
      alt: "",
      class: "h-10 w-10 rounded-full object-cover"
    }, null, 8, v)) : (t(), i("div", {
      key: 1,
      class: c(["h-10 w-10 rounded-full flex items-center justify-center text-gray-500 dark:text-neutral-200", [e.borderColor ? "border" : "ct-bg-3"]]),
      style: m({
        color: e.textColor,
        borderColor: e.borderColor
      })
    }, [
      e.name ? (t(), i("p", I, d(l.initials), 1)) : (t(), n(s, {
        key: 1,
        class: "h-5 w-5"
      }))
    ], 6)),
    e.icon ? (t(), n(g(e.icon), {
      key: 2,
      class: "absolute -top-1 -left-1 w-4 h-4"
    })) : h("", !0)
  ]);
}
const z = /* @__PURE__ */ u(k, [["render", j]]);
export {
  B as AvatarMd,
  z as AvatarSm
};
